import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { QuestionnaireService } from '../../../../services/questionnaire.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../store/app.states';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatOptionSelectionChange } from '@angular/material/core';
import { ErrorDialogComponent } from '../../../user-actions/error-dialog/error-dialog.component';
import { Q_DATA_CONSENT, DataConsentResults } from '../../../../model/questionnaires/questionnaire-data-consent';
import { User } from '../../../../model/user/User';

@Component({
  selector: 'app-questionnaire-data-consent',
  templateUrl: './questionnaire-data-consent.component.html',
  styleUrls: ['./questionnaire-data-consent.component.css']
})
export class QuestionnaireDataConsentComponent implements OnInit {

  qForm: FormGroup;
  dataSource = Q_DATA_CONSENT;
  notFocused = false;
  submitted = false;
  show = false;
  displayedColumns = ['position', 'question', 'value'];
  values: string[] = ['si', 'no'];
  results = [];

  /// toolbar
  back = true;
  found = false;
  title = 'Consenso Informato';
  destination = '/questionnaires';
  user: User = null;
  uuid = null;
  authorization: boolean;
  doctorID: string;
  patientSSN: string;

  constructor(private questionnaireService: QuestionnaireService,
    private store: Store<AppState>,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private router: Router) { }

  ngOnInit(): void {

    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.dataSource.length; ++i) {
      this.results.push(null);
    }

    this.user = JSON.parse(localStorage.getItem('user'));
    this.route.params.subscribe(params => {
      this.doctorID = params.doctorID;
      this.patientSSN = params.patientSSN;
      this.uuid = params.uuid;
      this.authorization = this.user.ssn.localeCompare(params.patientSSN) === 0;
      if (params.back && params.back.localeCompare('questionnaires') === 0) {
        this.destination = 'questionnaires';
      } else if (params.back && params.back.localeCompare('choose-questionnaire') === 0) {
        this.destination = 'choose-questionnaire';
      }
    });
  }

  selectResult(value: string, position: number) {
    this.results[position - 1] = value;
  }


  onSubmit() {
    this.submitted = true;
    this.show = true;
    this.found = false;

    if (this.results.length !== this.dataSource.length) {
      this.show = false;
      this.submitted = false;
      this.found = true;
      const msg = 'Devi rispondere alla domanda di consenso.';
      this.openErrorDialog(msg);
    } else {
      for (const r of this.results) {
        if (r === null) {
          this.show = false;
          this.submitted = false;
          this.found = true;
          const msg = 'Devi rispondere alla domanda di consenso.';
          this.openErrorDialog(msg);
          break;
        }
      }

      if (!this.found) {
        const resultToSend = new DataConsentResults(this.doctorID, this.patientSSN, this.results);
        this.questionnaireService.sendForm(resultToSend, 'mmas8', this.uuid);
      }
    }
  }

  openErrorDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Finestra chiusa');
    });
  }

  goHome() {
    if (this.user === null) {
      this.router.navigateByUrl('/startup');
    } else {
      this.router.navigateByUrl('/landing');
    }
  }

}
